import SectionLabel from "../common/SectionLabel";
import SkillColumn from "./SkillColumn";
import { skillGroups } from "../../data/skills";

function Skills() {
  return (
    <section id="skills" className="divider">
      <div className="wrap">
        <SectionLabel label="skills" />
        <div className="skills-grid">
          {skillGroups.map((group) => (
            <SkillColumn group={group} key={group.title} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;
